import React from 'react';
import {Button} from '@br/br-components';
import {WarnerMedia} from '../../endpoints';

import PhoneInput from '../molecules/phoneInput';

class PhoneLogin extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.onClick = this.onClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(event, phone) {
    event.preventDefault();
    this.props
      .onPhoneSubmit(phone)
      .then(
        async () => {
          this.setState({errors: []});
          this.props.stepCompleted();
          await this.props.mParticleLogin(
            {
              email: '',
            },
            {
              loggedIn: true,
              signup_source: 'phone',
              account_verified: true,
            }
          );
          this.props.trackEvent({
            tag_manager_event: 'login',
            accountType: 'phone',
            loginSuccess: true,
            screen: this.props.pageType || 'Login',
          });
        },
        () => {
          this.props.trackEvent({
            tag_manager_event: 'login',
            accountType: 'phone',
            loginSuccess: false,
            screen: this.props.pageType || 'Login',
          });
        }
      )
      .catch((err) => {
        this.setState({errors: [err]});
      });
  }

  onClick(event) {
    event.preventDefault();
    this.props.stepCompleted(true, 'choosemethod');
  }

  render() {
    return (
      <PhoneInput
        errors={this.state.errors}
        onSubmit={this.onSubmit}
        buttonText="Send SMS Verification"
        title="Sign In with Your Phone"
        legalDisclaimer={
          <p>
            By proceeding, you agree to the <a href="/pages/terms">Terms of Use</a> and acknowledge
            the <a href={WarnerMedia.privacy()}>Privacy Policy</a>.
          </p>
        }
      >
        <Button href="/sign_in" onClick={this.onClick}>
          Sign In with Facebook or Email
        </Button>
        {this.props.children}
      </PhoneInput>
    );
  }
}

PhoneLogin.defaultProps = {
  onPhoneSubmit: () => {}, //stub
};

export default PhoneLogin;
